import useAppQuery from 'hooks/useAppQuery';
import IntegrationsAPI from 'services/IntegrationsAPI';
import useAppUser from 'hooks/useAppUser';
import { ScreenAndProtectEnrollmentResponse } from 'models/ScreenAndProtect';

export const SCREEN_AND_PROTECT_ENROLLMENT_BASE_QUERY_KEY =
  'screen-and-protect-enrollment';

const useFetchScreenAndProtectEnrollment = () => {
  const { agencyUid } = useAppUser();
  const { data, isFetching } = useAppQuery(
    [SCREEN_AND_PROTECT_ENROLLMENT_BASE_QUERY_KEY, agencyUid],
    async () => {
      const response =
        await IntegrationsAPI.get<ScreenAndProtectEnrollmentResponse>(
          `/api/internal/screen-and-protect/enrollment/${agencyUid}`,
        );
      return response.data;
    },
    {
      enabled: !!agencyUid,
    },
  );

  const isEnrolled = data?.isActive ?? false;
  const propertiesUids = data?.propertiesUids ?? [];
  const activeSince = data?.activeSince ?? null;

  return { isEnrolled, propertiesUids, activeSince, isLoading: isFetching };
};

export default useFetchScreenAndProtectEnrollment;
